import { createContext, useContext, useEffect, useReducer } from "react";
import SurveySectionReducer from "./SurveySectionReducer";
import { decryptData, encryptData } from "utils/encryptionUtil";

// Initialize from sessionStorage (with decryption)
const INITIAL_SECTION_STATE = {
	currentSurveySection: decryptData(sessionStorage.getItem("surveyTrack")),
};

export const SurveySectionContext = createContext({
	currentSurveySection: INITIAL_SECTION_STATE.currentSurveySection,
	dispatch: () => null,
});

export const SurveySectionProvider = ({ children }) => {
	const [state, dispatch] = useReducer(
		SurveySectionReducer,
		INITIAL_SECTION_STATE
	);

	useEffect(() => {
		if (state.currentSurveySection) {
			const encrypted = encryptData(state.currentSurveySection);
			if (encrypted) {
				sessionStorage.setItem("surveyTrack", encrypted);
			}
		}
	}, [state.currentSurveySection]);

	return (
		<SurveySectionContext.Provider
			value={{
				currentSurveySection: state.currentSurveySection,
				dispatch,
			}}
		>
			{children}
		</SurveySectionContext.Provider>
	);
};

export const useSurveySectionContent = () => {
	const context = useContext(SurveySectionContext);
	if (!context) {
		throw new Error(
			"useSurveySectionContent must be used within a SurveySectionProvider"
		);
	}
	return context;
};
